import preview from '@/assets/solution/background-blur/preview.png';
import infoItem1 from '@/assets/solution/background-blur/info-item-1.png';
import infoItem2 from '@/assets/solution/background-blur/info-item-2.png';
import infoItem3 from '@/assets/solution/background-blur/info-item-3.png';

export default {
  preview,
  toolName: 'blur',
  solutionName: 'Background Blur',
  videoUrl: 'https://www.youtube.com/embed/ZGgoh-haY2c',
  toolUrl: '/background-blur',
  infoList: [
    {
      title: 'Highlight Your Products',
      content: 'Background blur is quite useful in product photography, particularly when highlighting small or intricate details of a product, such as jewelry, where a blurred background can help to make the product appear larger and more detailed. By blurring the background, the product can be isolated and made to stand out, helping to draw the viewer\'s attention to the product and increase its visual impact and appeal.',
      imageUrl: infoItem1,
      contentOffset: 70,
    },
    {
      title: 'Make the Portrait Stand Out',
      content: 'Background blur is quite common in portrait photographs. It helps to create a shallow depth of field and adds a sense of depth to the photograph, thus creating a more visually appealing background. By blurring the background, the portrait becomes the focal point of the image, while the background fades away, thus helping to create a more pleasing and aesthetic image.',
      imageUrl: infoItem2,
      contentOffset: 30,
    },
    {
      title: 'Enhance the Appeal of Social Media Content',
      content: 'Background blur can be an effective technique to make the subject of social media posts and stories stand out from the background, resulting in a more visually appealing image. By using it, the subject can be presented in a more polished and professional manner, making it more likely to capture the attention of viewers and generate engagement, thus enhancing the impact and appeal of social media content.',
      imageUrl: infoItem3,
      contentOffset: 25,
    }
  ],
  steps: [
    {
      name: 'Upload',
      details: [
        'Upload images you want to blur background to.',
      ]
    },
    {
      name: 'Edit',
      details: [
        'Adjust the blur strength to change the depth effect.'
      ],
    },
    {
      name: 'Download',
      details: [
        'Click \'Download\' to save your images.',
      ],
    }
  ]
};
